import { Button, Form, Input, message, Spin } from "antd";
import { isAxiosError } from "axios";
import { useState } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@hooks";
import { ArrowLeft, EnvelopeSimple } from "@phosphor-icons/react";

export const Login = () => {
  const [emailSent, setEmailSent] = useState(false);
  const [userEmail, setUserEmail] = useState("");
  const [form] = Form.useForm();

  const { sendAccessLink, profile } = useAuth();
  const { data: profileData, isLoading: isLoadingData } = profile;

  const handleSendAccessLink = (data: { email: string }) => {
    setUserEmail(data.email);
    sendAccessLink.mutate(data.email, {
      onSuccess: () => {
        setEmailSent(true);
        message.success(`Access link sent to ${data.email}`);
      },
      onError: (error) => {
        const defaultMessage = "Error sending access link";
        if (isAxiosError(error)) {
          message.error(error.response?.data.message || defaultMessage);
        } else {
          message.error(defaultMessage);
        }
      },
    });
  };

  if (!isLoadingData && profileData?.email) {
    return <Navigate to="/" />;
  }

  return (
    <Spin spinning={sendAccessLink.isPending}>
      <div className="flex flex-col min-h-screen bg-[url(/assets/images/estabrook-home-pic.png)] bg-cover bg-center">
        <div className="absolute inset-0 bg-black/50"></div>
        
        <div className="flex flex-col items-center justify-center min-h-screen w-full p-4 md:p-10 z-10">
          <a href="/" className="flex items-center gap-3 text-white-hover-primary text-lg md:text-xl w-fit mb-8">
            <ArrowLeft size={25}/>
            Back to website
          </a>

          <div className="flex mb-10">
            <img src="/assets/images/estabrook-E-logo.png" alt="Estabrook" className="w-25" />
          </div>

          {!emailSent ? (
            <Form
              form={form}
              name="login"
              className="bg-white !p-6 w-full max-w-sm container-single-cut"
              onFinish={handleSendAccessLink}
              layout="vertical"
            >
              <Form.Item
                label={<span className="text-charcoal text-base">Email</span>}
                name="email"
                rules={[{ required: true, message: "Please enter your email!" }]}
              >
                <Input placeholder="email@email.com" />
              </Form.Item>
              <div className="text-sm text-charcoal text-base text-center mb-8">
                We'll send you an access link to your email for secure, password-free login.
              </div>
              <div className="text-center">
                <Button htmlType="submit" className="btn-double-cut !w-fit">
                  Send access link
                </Button>
              </div>
            </Form>
          ) : (
            <div className="bg-white container-single-cut text-center w-full max-w-sm p-8">
              <div className="flex justify-center mb-4">
                <EnvelopeSimple size={48} weight="regular" className="text-primary" />
              </div>
              <h2 className="text-xl font-semibold mb-2 text-charcoal">Check your email</h2>
              <p className="text-charcoal mb-6">
                We've sent an access link to <span className="text-charcoal">{userEmail}</span>
                <br />
                Click the link in the email to sign in.
              </p>
              <Button type="link" className="btn-single-cut" onClick={() => setEmailSent(false)}>
                Try another email
              </Button>
            </div>
          )}
        </div>
      </div>
    </Spin>
  );
};